import React from 'react';
import { Card, CardContent, CardHeader, Divider } from '@mui/material';

type Props = { title: string; subtitle?: string; children: React.ReactNode };

export default function SectionCard({ title, subtitle, children }: Props) {
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader title={title} subheader={subtitle} />
      <Divider />
      <CardContent>{children}</CardContent>
    </Card>
  );
}
